export default __webpack_public_path__ + "static/pantaley.com-3324cfc8ad0f867bbedcba49b966acff.png";